import type { HostedAuthPlugin } from '@unipile/ui';
import { facebookProductIcons } from '../products';
import { Wizard } from './components/Wizard';

export const facebookHaPlugin: HostedAuthPlugin = {
  Component: Wizard,
  productIcons: facebookProductIcons,
  registerTrads({ locales, i18n }) {
    return Promise.all(
      locales.map(async (locale) => {
        const data: { default: object } = await import(`./translations/${locale}.json`);
        i18n.addResourceBundle(locale, 'facebook', data.default);
      }),
    );
  },
};
